import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRules = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.907 3.23a.6.6 0 0 1 0 .85L16 5.986a.7.7 0 0 1-.99 0l-.945-.945a.6.6 0 0 1 .848-.849l.592.592 1.554-1.554a.6.6 0 0 1 .848 0m0 5.38a.6.6 0 0 1 0 .848L16 11.366a.7.7 0 0 1-.99 0l-.945-.946a.6.6 0 0 1 .848-.848l.592.591 1.554-1.553a.6.6 0 0 1 .848 0"
      clipRule="evenodd"
    />
    <path d="M16.551 17.079a.6.6 0 0 0 .849-.849l-.565-.565.564-.564a.6.6 0 1 0-.848-.849l-.565.565-.564-.565a.6.6 0 0 0-.849.849l.565.564-.565.565a.6.6 0 1 0 .848.849l.565-.565zM3 4.729c0-.88.713-1.593 1.592-1.593h6.37a1.592 1.592 0 0 1 0 3.185h-6.37C3.712 6.321 3 5.608 3 4.73Zm0 5.355c0-.88.713-1.592 1.592-1.592h6.37a1.592 1.592 0 0 1 0 3.185h-6.37c-.88 0-1.592-.713-1.592-1.593m0 5.694c0-.88.713-1.592 1.592-1.592h6.37a1.592 1.592 0 0 1 0 3.184h-6.37c-.88 0-1.592-.713-1.592-1.592" />
  </svg>
);
export default SvgRules;
